var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-settings"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    clipPath: "url(#clip-settings)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(-44.5 -864.363)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings_1_",
    "data-name": "settings (1)",
    transform: "translate(45 864.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M20.724,39H18.276a3.594,3.594,0,0,1-3.59-3.59v-.828a15.745,15.745,0,0,1-2.445-1.015l-.587.587a3.59,3.59,0,0,1-5.078,0l-1.73-1.73a3.59,3.59,0,0,1,0-5.078l.586-.586a15.745,15.745,0,0,1-1.015-2.445H3.59A3.594,3.594,0,0,1,0,20.724V18.276a3.594,3.594,0,0,1,3.59-3.59h.828a15.749,15.749,0,0,1,1.015-2.445l-.587-.587a3.59,3.59,0,0,1,0-5.078l1.73-1.73a3.59,3.59,0,0,1,5.078,0l.586.586a15.759,15.759,0,0,1,2.445-1.015V3.59A3.594,3.594,0,0,1,18.276,0h2.448a3.594,3.594,0,0,1,3.59,3.59v.828a15.744,15.744,0,0,1,2.445,1.015l.587-.587a3.59,3.59,0,0,1,5.078,0l1.73,1.73a3.59,3.59,0,0,1,0,5.078l-.586.586a15.747,15.747,0,0,1,1.015,2.445h.828A3.594,3.594,0,0,1,39,18.276v2.448a3.594,3.594,0,0,1-3.59,3.59h-.828a15.749,15.749,0,0,1-1.015,2.445l.587.587a3.59,3.59,0,0,1,0,5.078l-1.73,1.73a3.59,3.59,0,0,1-5.078,0l-.586-.586a15.759,15.759,0,0,1-2.445,1.015v.828A3.594,3.594,0,0,1,20.724,39Zm-8.1-7.833a13.468,13.468,0,0,0,3.491,1.449,1.143,1.143,0,0,1,.857,1.106V35.41a1.307,1.307,0,0,0,1.305,1.305h2.448a1.307,1.307,0,0,0,1.305-1.305V33.723a1.143,1.143,0,0,1,.857-1.106,13.468,13.468,0,0,0,3.491-1.449,1.143,1.143,0,0,1,1.39.176l1.195,1.2a1.3,1.3,0,0,0,1.845,0l1.731-1.731a1.3,1.3,0,0,0,0-1.845l-1.2-1.2a1.143,1.143,0,0,1-.176-1.39,13.466,13.466,0,0,0,1.449-3.491,1.143,1.143,0,0,1,1.106-.857H35.41a1.307,1.307,0,0,0,1.305-1.305V18.276a1.307,1.307,0,0,0-1.305-1.305H33.723a1.143,1.143,0,0,1-1.106-.857,13.469,13.469,0,0,0-1.449-3.491,1.143,1.143,0,0,1,.176-1.39l1.2-1.2a1.3,1.3,0,0,0,0-1.845L30.807,6.462a1.3,1.3,0,0,0-1.845,0l-1.2,1.2a1.143,1.143,0,0,1-1.39.176,13.468,13.468,0,0,0-3.491-1.449,1.143,1.143,0,0,1-.857-1.106V3.59a1.307,1.307,0,0,0-1.305-1.305H18.276A1.307,1.307,0,0,0,16.971,3.59V5.277a1.143,1.143,0,0,1-.857,1.106,13.468,13.468,0,0,0-3.491,1.449,1.143,1.143,0,0,1-1.39-.176l-1.195-1.2a1.3,1.3,0,0,0-1.845,0L6.462,8.193a1.3,1.3,0,0,0,0,1.845l1.2,1.2a1.143,1.143,0,0,1,.176,1.39,13.466,13.466,0,0,0-1.449,3.491,1.143,1.143,0,0,1-1.106.857H3.59a1.307,1.307,0,0,0-1.305,1.305v2.448A1.307,1.307,0,0,0,3.59,22.029H5.277a1.143,1.143,0,0,1,1.106.857,13.468,13.468,0,0,0,1.449,3.491,1.143,1.143,0,0,1-.176,1.39l-1.2,1.2a1.3,1.3,0,0,0,0,1.845l1.731,1.731a1.3,1.3,0,0,0,1.845,0l1.2-1.2a1.148,1.148,0,0,1,1.39-.175Z",
    transform: "translate(0 0)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M153.086,161.571a8.486,8.486,0,1,1,8.486-8.486A8.5,8.5,0,0,1,153.086,161.571Zm0-14.686a6.2,6.2,0,1,0,6.2,6.2,6.207,6.207,0,0,0-6.2-6.2Z",
    transform: "translate(-133.586 -133.586)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.25
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.512b357744ea966a9424162717f59831.svg";
export { ForwardRef as ReactComponent };